<template>
  <compare-tool
    ref="compareTool"
    :selectedComponent="selectedComponent"
    :chartTabContent="chartTabContent"
    :chartData="chartGraphData"
    :tooltipData="chartTooltipData"
    :tooltipDataProp="chartTooltipDataProp"
    :chartProperties="chartProperties"
    :compareGraphProp="compareGraphProp"
    :compareGraphOwners="compareGraphOwners"
    :compareGraphOption="compareGraphOption"
    :projectionYear="projectionYear"
    :tooltipHeader="tooltipHeader"
    :pageHeadingInfo="pageHeadingInfo"
    :headers="headersdata"
    :rowsdata="rowsdata"
    :groupedRows="grouprow"
    :mainHeading="mainHeading"
    @onBack="onBack"
    @submit="applyFilter"
    @onChangeChartTab="onChangeChartTab"
  ></compare-tool>
</template>
<script>
import { LoanEngagementTool } from "../../mixin";
import { CompareTool } from "../../component/tool";
import {
  AdvanceFilter,
  RepeymentTypeSelectOptions,
} from "../../helpers/constant";
import { CommonHelper } from "../../helpers";
import { ICELoanIntegration } from "../../mixin";

import {
  GET_COMPARE_LOAN_INFO,
  SET_COMPARE_LOAN_INFO,
  SET_LOADER_VISIBILITY,
} from "../../helpers/vuex-constants";
import { mapActions, mapGetters } from "vuex";

export default {
  components: { CompareTool },
  computed: {
    ...mapGetters("loan", {
      CompareLoanInfo: GET_COMPARE_LOAN_INFO,
    }),
    parentContainerWidth() {
      return this.$refs.compareTool.getScreenWidth();
    },
  },
  async mounted() {
    await this.getProjectionData(0);
    this.compareModel();
  },
  data() {
    return {
      projectionDetails: [],
      compareGraphOwners: [],
      mainHeading: "Table Comparison",
      lineChartData: [],
      chartGraphData: [],
      startingYear: 0,
      rootWidth: 0,
      headersdata: [],
      rowsdata: {},
      tooltipHeader: [],
      tooltipData: [],
      linetooltipData: [],
      selectedComponent: "chart-line-group",
      xAxisArray: [],
      xAxisMinValue: 0,
      lineAxisArray: [],
      barColors: ["#005ba1", "#a50032", "#f5c400", "#00af41", "#00a8e1"],
      pageHeadingInfo: {
        heading: "Compare different loan instances",
        subHeading:
          "You can use the information to decide on strategies for a desired outcome",
      },
      compareGraphProp: "Total Repayment",
      tooltipDataProp: [
        "Balance",
        "Principal Paid To Date",
        "Interest Paid To Date",
        "Repayments Paid To Date",
      ],
      bartooltipDataProp: [
        "Balance",
        "Principal Paid",
        "Interest Paid",
        "Repayment",
      ],

      compareGraphOption: [],

      barChartData: [],

      chartTabContent: [
        {
          text: "Balance",
          id: "lineChart",
          active: true,
        },
        {
          text: "Repayments",
          id: "barChart",
          active: false,
        },
      ],
      selectedtabId: "lineChart",
      grouprow: [
        {
          heading: "Key Details",
          expanded: true,
          visible: true,
          groupid: "groupid1",
          columns: [
            {
              text: "Initial Balance",
              name: "InitialBalance",
              type: "String",
              style: {
                width: "230px",
              },
            },
            {
              text: "Baseline Interest Rate",
              name: "BaselineInterest",
              type: "String",
              style: {
                width: "230px",
              },
            },
            {
              text: "Total Loan Repayment",
              name: "TotalLoanRepayment",
              type: "String",
              style: {
                width: "230px",
              },
            },
            {
              text: "Total Interest",
              name: "TotalInterest",
              type: "String",
              style: {
                width: "230px",
              },
            },
            {
              text: "Loan Paid In",
              name: "LoanPaidIn",
              type: "String",
              style: {
                width: "230px",
              },
            },
          ],
        },
        {
          heading: "Additional",
          expanded: true,
          visible: true,
          groupid: "groupid2",
          style: {
            width: "230px",
          },

          columns: [
            {
              visible: true,
              text: "Interest Rate",
              name: "InterestRate",
              type: "DataList",
              style: {
                width: "230px",
              },
            },
            // {
            //   text: "Baseline Interest Rate",
            //   name: "BaselineInterestRate",
            //   type: "String",
            // },
          ],
        },
      ],
    };
  },

  beforeDestroy() {
    this.setCompareLoanInfo([]);
  },
  mixins: [LoanEngagementTool, ICELoanIntegration],
  methods: {
    ...mapActions({
      setLoaderVisibility: SET_LOADER_VISIBILITY,
    }),
    async applyFilter() {
      if (this.projectionYear.Value > 0) {
        this.tooltipHeader = [];
        this.tooltipData = [];
        this.linetooltipData = [];
        this.xAxisArray = [];
        this.lineAxisArray = [];
        this.barChartData = [];
        this.lineChartData = [];
        await this.getProjectionData(this.projectionYear.Value);
        this.compareModel();
      }
    },
    async getProjectionData(projectionYear) {
      let baselineDataArray = this.ConvertLoanstoModel(projectionYear);
      let apiModel = this.prepareAPIModelArray(baselineDataArray);
      this.setLoaderVisibility(true);
      const projectionData = await this.getLoanProjection(apiModel);
      this.setLoaderVisibility(false);
      if (
        projectionData &&
        projectionData.loanProjectionResult &&
        projectionData.loanProjectionResult.length > 0
      ) {
        this.projectionDetails = projectionData.loanProjectionResult;
        this.startingYear =
          projectionData.loanProjectionResult[0].loanProjection[0].year;
        this.fillBarChartData(
          this.startingYear,
          this.startingYear + apiModel.ProjectionDuration
        );
        this.filllineChartData(
          this.startingYear,
          this.startingYear + apiModel.ProjectionDuration
        );
        this.xAxisMinValue = this.startingYear;
        this.resetBarChartProp(projectionData, baselineDataArray);
        this.resetLineChartProp(projectionData, baselineDataArray);
        this.onChangeChartTab(this.selectedtabId);
      }
    },

    getScreenWidth() {
      this.rootWidth =
        this.parentContainerWidth -
        (this.barChartProperties.axisRightWidth +
          this.barChartProperties.axisRightWidth);
    },
    ConvertLoanstoModel(projectionYear) {
      let totalLoan = this.CompareLoanInfo.length;
      let baselineLoanArray = [];
      for (let i = 0; i < totalLoan; i++) {
        let baselineLoan = {};
        if (
          projectionYear == 0 &&
          this.projectionYear.Value < this.CompareLoanInfo[i].projectionYear
        ) {
          this.projectionYear.Value = this.CompareLoanInfo[i].projectionYear;
        }
        baselineLoan.openingBalance = this.CompareLoanInfo[i].outstandingAmount;
        baselineLoan.interestRate = this.CompareLoanInfo[i].interestRate;
        baselineLoan.repaymentType = this.CompareLoanInfo[i].liabilityTypeId;
        baselineLoan.repaymentAmount = this.CompareLoanInfo[i].repaymentAmount;
        baselineLoan.repaymentFrequency =
          this.CompareLoanInfo[i].durationTypeId;
        baselineLoan.taxDeductibilityPercent =
          this.CompareLoanInfo[i].taxDeductibility;

        baselineLoan.loanTerm =
          this.CompareLoanInfo[i].term * 12 + this.CompareLoanInfo[i].months;
        baselineLoan.loanTypeId = this.CompareLoanInfo[i].loanTypeId;
        baselineLoan.entityType = this.CompareLoanInfo[i].entityType;
        baselineLoan.description = this.CompareLoanInfo[i].description;
        baselineLoan.uniqueId = CommonHelper.uuidv4();
        baselineLoan.advancedetails = this.CompareLoanInfo[i].advancedetails;
        baselineLoanArray.push(baselineLoan);
      }
      return baselineLoanArray;
    },
    compareModel() {
      let data = this.CompareLoanInfo;
      let Headers = [];
      let AdditionalRowVisible = false;
      let rows = {
        groupid1: {},
        groupid2: {},
        // groupid3: []
      };

      Headers.push({
        text: "Include in Holistic",
        fieldName: "heading",
        switchRequied: false,
        style: {
          width: "230px",
        },
      });
      for (let i = 0; i < 5; i++) {
        if (i <= data.length - 1) {
          rows["groupid1"][data[i].liabilityGuid.toString()] = {
            InitialBalance: CommonHelper.convertIntoCurrencyWithoutDecimal(
              data[i].outstandingAmount
            ),
            BaselineInterest: data[i].interestRate.toFixed(2) + "%",
            TotalLoanRepayment: CommonHelper.convertAmountIntoCurrency(
              this.projectionDetails[i]
                ? this.projectionDetails[i].totalLoanRepayment
                : ""
            ),
            TotalInterest: CommonHelper.convertAmountIntoCurrency(
              this.projectionDetails[i]
                ? this.projectionDetails[i].totalInterest
                : ""
            ),
            LoanPaidIn: this.projectionDetails[i]
              ? this.projectionDetails[i].LoanPaindId == "-"
                ? ""
                : this.projectionDetails[i].LoanPaindId
              : "",
          };
          let additionalData = [];
          if (data[i].advancedetails != null) {
            additionalData = data[i].advancedetails
              .filter((sr) => sr.typeId != AdvanceFilter.LoanTerm)
              .map((r) => {
                let p = {
                  label: null,
                  typeId: null,
                  data: [],
                };

                let startMonth =
                  !r.startDate || r.startDate == ""
                    ? r.startDate
                    : CommonHelper.getMonthName(
                        CommonHelper.getMonthfromMonthYear(r.startDate)
                      );
                let startYear =
                  !r.startDate || r.startDate == ""
                    ? r.startDate
                    : CommonHelper.getYearfromMonthYear(r.startDate);
                let endMonth =
                  !r.endDate || r.endDate == ""
                    ? r.endDate
                    : CommonHelper.getMonthName(
                        CommonHelper.getMonthfromMonthYear(r.endDate)
                      );
                let endYear =
                  !r.endDate || r.endDate == ""
                    ? r.endDate
                    : CommonHelper.getYearfromMonthYear(r.endDate);

                p.typeId = r.typeId;
                if (r.description == undefined || r.description != "") {
                  p.label = r.description;
                } else {
                  p.label = this.DescriptionAdditionalForm(
                    r.descriptionplaceholder,
                    r.typeId
                  );
                }
                if (r.typeId == 1) {
                  p.data[0] = `Interest rate ${r.amount} %`;
                } else if (r.typeId == 2) {
                  p.data[0] = `${r.amount == 0 ? "" : "$" + r.amount}   ${
                    r.repaymentType > 0
                      ? RepeymentTypeSelectOptions.filter(
                          (x) => x.value == r.repaymentType
                        )[0].text
                      : CommonHelper.getRaymentType(r.subTypeId)
                  }   `;
                } else if (r.typeId == 4) {
                  p.data[0] = CommonHelper.calculateMonth(r.amount);
                }
                if (r.typeId == 4) {
                  p.data[1] = startMonth + " " + startYear;
                } else if (r.typeId == 3) {
                  p.data[0] = `${CommonHelper.convertAmountIntoCurrency(
                    r.amount
                  )}  ${CommonHelper.getFrequencyName(r.frequency)} `;

                  p.data[1] = `${CommonHelper.convertAmountIntoCurrency(
                    r.amount
                  )}  ${CommonHelper.getFrequencyName(r.frequency)} `;
                  p.data[2] = `${startMonth}
            ${startYear} ${endMonth ? "-" : ""} ${endMonth} 
            ${endYear}`;
                } else {
                  p.data[1] = `${startMonth}
            ${startYear} ${endMonth ? "-" : ""} ${endMonth} 
            ${endYear}`;
                }
                return p;
              });
          }
          if (!AdditionalRowVisible) {
            AdditionalRowVisible = additionalData.length > 0;
          }
          rows["groupid2"][data[i].liabilityGuid.toString()] = {
            InterestRate: { listdata: additionalData },
            //  BaselineInterestRate: data[i].interestRate + "%",
          };

          Headers.push({
            text: data[i].description,
            fieldName: data[i].liabilityGuid.toString(),
            switchRequied: true,
            colour: this.barChartProperties.color[i],
          });
        } else {
          rows["groupid1"]["blank" + i] = {
            InitialBalance: "",
            BaselineInterest: "",
            TotalLoanRepayment: "",
            TotalInterest: "",
            LoanPaidIn: "",
          };

          // AdditionalRowVisible = false;
          rows["groupid2"]["blank" + i] = {
            InterestRate: { listdata: [] },
            //  BaselineInterestRate: data[i].interestRate + "%",
          };

          Headers.push({
            text: "",
            fieldName: "blank" + i,
            switchRequied: true,
            colour: this.barChartProperties.color[i],
          });
        }
      }

      this.headersdata = Headers;
      this.rowsdata = rows;
      this.grouprow.filter((x) => x.groupid == "groupid2")[0].visible =
        AdditionalRowVisible;
    },
    resetLineChartProp(projectionData, baselineDataArray) {
      let totalLoan = projectionData.loanProjectionResult.length;
      let colors = [];
      let legends = [];
      let maxYAxis = 0;
      this.tooltipHeader.push({ value: this.startingYear, type: "text" });
      for (let i = 0; i < totalLoan; i++) {
        let loan = baselineDataArray.filter(
          (sr) => sr.uniqueId == projectionData.loanProjectionResult[i].loanID
        );
        if (loan.length == 0) {
          continue;
        }
        colors.push(this.barColors[i]);
        legends.push(loan[0].description);
        this.tooltipHeader.push({
          value: loan[0].description,
          type: "legendText",
          color: this.barColors[i],
        });

        for (
          let j = 0;
          j < projectionData.loanProjectionResult[i].loanProjection.length;
          j++
        ) {
          if (
            maxYAxis <
            projectionData.loanProjectionResult[i].loanProjection[j]
              .closingBalance
          ) {
            maxYAxis =
              projectionData.loanProjectionResult[i].loanProjection[j]
                .closingBalance;
          }

          if (j == 0) {
            if (
              maxYAxis <
              projectionData.loanProjectionResult[i].loanProjection[j]
                .openingBalance
            ) {
              maxYAxis =
                projectionData.loanProjectionResult[i].loanProjection[j]
                  .openingBalance;
            }
            this.lineChartData[j].value.push({
              id: `${i}-${j}`,
              value:
                projectionData.loanProjectionResult[i].loanProjection[j]
                  .openingBalance,
            });
            this.linetooltipData[j].value.push({
              id: `${i}-${j}`,
              value: this.fillToopTipDataAtZeroIndex(loan[0].openingBalance),
            });
          }

          this.lineChartData[j + 1].value.push({
            id: `${i}-${j}`,
            value:
              projectionData.loanProjectionResult[i].loanProjection[j]
                .closingBalance,
          });

          this.linetooltipData[j + 1].value.push({
            id: `${i}-${j}`,
            value: this.fillToopTipData(
              projectionData.loanProjectionResult[i].loanProjection[j]
            ),
          });
        }
      }
      this.ResetlineChartProperties(maxYAxis, totalLoan, colors, legends);
    },
    resetBarChartProp(projectionData, baselineDataArray) {
      let totalLoan = projectionData.loanProjectionResult.length;
      let colors = [];
      let legends = [];
      let maxYAxis = 0;
      this.tooltipHeader.push({ value: this.startingYear, type: "text" });
      for (let i = 0; i < totalLoan; i++) {
        let loan = baselineDataArray.filter(
          (sr) => sr.uniqueId == projectionData.loanProjectionResult[i].loanID
        );
        if (loan.length == 0) {
          continue;
        }
        colors.push(this.barColors[i]);
        legends.push(loan[0].description);
        this.tooltipHeader.push({
          value: loan[0].description,
          type: "legendText",
          color: this.barColors[i],
        });

        for (
          let j = 0;
          j < projectionData.loanProjectionResult[i].loanProjection.length;
          j++
        ) {
          if (
            maxYAxis <
            projectionData.loanProjectionResult[i].loanProjection[j]
              .repaymentAll
          ) {
            maxYAxis =
              projectionData.loanProjectionResult[i].loanProjection[j]
                .repaymentAll;
          }
          this.barChartData[j].value.push({
            id: `${i}-${j}`,
            value:
              projectionData.loanProjectionResult[i].loanProjection[j]
                .repaymentAll,
          });

          this.tooltipData[j].value.push({
            id: `${i}-${j}`,
            value: this.fillBarToolTipData(
              projectionData.loanProjectionResult[i].loanProjection[j]
            ),
          });
        }
      }
      this.ResetBarChartProperties(maxYAxis, totalLoan, colors, legends);
    },
    ResetlineChartProperties(maxYAxis, totalLoan, colors, legends) {
      this.lineChartProperties.color = colors;
      this.lineChartProperties.legendItems = legends;
      let roundOffYaxis = CommonHelper.getRoundOffValueForAxis(
        0,
        Math.ceil(maxYAxis),
        5
      );
      if (roundOffYaxis < 5) {
        roundOffYaxis = 5;
      }
      this.lineChartProperties.domainX = [];
      this.lineChartProperties.domainY = [0, roundOffYaxis];
      this.lineChartProperties.labelNameY = "Loan Balance";
      this.getScreenWidth();
      let width = this.rootWidth;

      this.lineChartProperties.domainX = [0, this.projectionYear.Value];

      this.lineChartProperties.tickX = 0;
      this.lineChartProperties.width = width;
      this.lineChartProperties.rangeX = [0, width];
      this.lineChartProperties.toolTipBoxWidth = (totalLoan + 1) * 135;
    },
    ResetBarChartProperties(maxYAxis, totalLoan, colors, legends) {
      this.barChartProperties.color = colors;
      this.barChartProperties.legendItems = legends;
      let roundOffYaxis = CommonHelper.getRoundOffValueForAxis(
        0,
        Math.ceil(maxYAxis),
        5
      );
      if (roundOffYaxis < 5) {
        roundOffYaxis = 5;
      }
      this.barChartProperties.domainX = this.xAxisArray;
      this.barChartProperties.domainY = [0, roundOffYaxis];
      this.getScreenWidth();
      let width = (totalLoan + 1) * 18 * this.projectionYear.Value;
      if (width < this.rootWidth) {
        width = this.rootWidth;
      }
      this.barChartProperties.width = width;
      this.barChartProperties.rangeX = [0, width];
      (this.barChartProperties.labelNameY = "Loan Repayment"),
        (this.barChartProperties.toolTipBoxWidth = (totalLoan + 1) * 135);
    },
    fillBarChartData(start, end) {
      for (let i = start; i < end; i++) {
        this.xAxisArray.push(i );
        this.barChartData.push({ id: i , value: [] });
        this.tooltipData.push({ id: i , value: [] });
      }
    },
    filllineChartData(start, end) {
      for (let i = start; i <= end; i++) {
        this.lineChartData.push({ id: i-1, value: [] });
        this.linetooltipData.push({ id: i-1, value: [] });
      }
    },
    fillToopTipDataAtZeroIndex(balance) {
      return {
        Balance: CommonHelper.convertIntoCurrencyWithoutDecimal(balance),
        "Principal Paid To Date":
          CommonHelper.convertIntoCurrencyWithoutDecimal(0),
        "Interest Paid To Date":
          CommonHelper.convertIntoCurrencyWithoutDecimal(0),
        "Repayments Paid To Date":
          CommonHelper.convertIntoCurrencyWithoutDecimal(0),
      };
    },
    fillBarToolTipData(data) {
      return {
        Balance: CommonHelper.convertIntoCurrencyWithoutDecimal(
          data.openingBalance
        ),
        "Principal Paid": CommonHelper.convertIntoCurrencyWithoutDecimal(
          data.capitalPaid
        ),
        "Interest Paid": CommonHelper.convertIntoCurrencyWithoutDecimal(
          data.interestPayable
        ),
        Repayment: CommonHelper.convertIntoCurrencyWithoutDecimal(
          data.repaymentAll
        ),
      };
    },
    fillToopTipData(data) {
      return {
        Balance: CommonHelper.convertIntoCurrencyWithoutDecimal(
          data.openingBalance
        ),
        "Principal Paid To Date":
          CommonHelper.convertIntoCurrencyWithoutDecimal(
            data.capitalPaidCumulative
          ),
        "Interest Paid To Date": CommonHelper.convertIntoCurrencyWithoutDecimal(
          data.interestPaidCumulative
        ),
        "Repayments Paid To Date":
          CommonHelper.convertIntoCurrencyWithoutDecimal(
            data.repaymentCumulative
          ),
      };
    },
    onBack() {
      this.$router.push({ name: "loan-instance-selection" });
    },
    ...mapActions("loan", {
      setCompareLoanInfo: SET_COMPARE_LOAN_INFO,
    }),

    onChangeChartTab(tabId) {
      this.selectedtabId = tabId;
      if (this.selectedtabId == "lineChart") {
        this.chartProperties = this.lineChartProperties;
        this.chartGraphData = this.lineChartData;
        this.selectedComponent = "chart-line-group";
        this.chartTooltipData = this.linetooltipData;
        this.chartTooltipDataProp = this.tooltipDataProp;
      } else {
        this.chartProperties = this.barChartProperties;
        this.selectedComponent = "chart-bar-group";
        this.chartGraphData = this.barChartData;
        this.chartTooltipData = this.tooltipData;
        this.chartTooltipDataProp = this.bartooltipDataProp;
      }
    },
  },
};
</script>
<style lang="scss" module></style>
